(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["biggar-cocktail-library"] && !Shopify.designMode) return;
  try {
    
class BiggarCocktailLibrary extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    const root = this.closest('.bcl');
    this.grid = root.querySelector('[data-grid]');
    this.cards = [...this.grid.querySelectorAll('[data-card]')];
    this.none = root.querySelector('[data-none]');
    this.search = this.querySelector('[data-search]');
    this.sort = this.querySelector('[data-sort]');
    this.count = this.querySelector('[data-count]');
    this.clear = this.querySelector('[data-clear]');
    this.filters = this.querySelector('[data-filters]');
    this.active = { spirit: '', technique: '', style: '' };
    this.buildFilters();
    this.readUrl();
    this.search.addEventListener('input', () => this.apply());
    this.sort.addEventListener('change', () => this.apply());
    this.clear.addEventListener('click', () => { this.search.value = ''; this.active = { spirit: '', technique: '', style: '' }; this.syncChips(); this.apply(); });
    this.hidden = false;
    this.apply();
    this.revealActive();
  }
  values(key) {
    const names = new Map();
    const counts = new Map();
    this.cards.forEach(card => {
      const handles = (card.dataset[key] || '').split(' ').filter(Boolean);
      const labels = (card.dataset[key + 'Name'] || '').split('|');
      handles.forEach((h, i) => { if (!names.has(h)) names.set(h, labels[i] || h); counts.set(h, (counts.get(h) || 0) + 1); });
    });
    let entries = [...names.entries()].map(([h, name]) => [h, name, counts.get(h)]);
    if (key === 'style') {
      const shared = entries.filter(([h, , n]) => n > 1 || h === 'biggar-original');
      if (shared.length >= 2) entries = shared;
    }
    return entries.sort((a, b) => a[1].localeCompare(b[1]));
  }
  styleOrder(options) {
    const handleize = s => String(s).toLowerCase().trim().replace(/['’"]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    const wanted = (this.dataset.stylesFirst || '').split(',').map(handleize).filter(Boolean);
    let primary;
    if (wanted.length) {
      primary = wanted.map(h => options.find(o => o[0] === h || handleize(o[1]) === h)).filter((o, i, list) => o && list.indexOf(o) === i);
    } else {
      const limit = Math.max(1, parseInt(this.dataset.stylesVisible, 10) || 8);
      primary = [...options].sort((a, b) => (b[0] === 'biggar-original') - (a[0] === 'biggar-original') || b[2] - a[2] || a[1].localeCompare(b[1])).slice(0, limit);
    }
    const chosen = new Set(primary.map(o => o[0]));
    return { primary, extra: options.filter(o => !chosen.has(o[0])) };
  }
  buildFilters() {
    ['spirit', 'technique', 'style'].forEach(key => {
      let options = this.values(key);
      if (options.length < 2) return;
      let extra = [];
      if (key === 'style') ({ primary: options, extra } = this.styleOrder(options));
      const labelText = this.dataset['label' + key[0].toUpperCase() + key.slice(1)];
      const group = document.createElement('div');
      group.className = 'bcl-group';
      group.setAttribute('role', 'group');
      group.setAttribute('aria-label', labelText);
      const label = document.createElement('span');
      label.className = 'bcl-group-label';
      label.textContent = labelText;
      const row = document.createElement('div');
      row.className = 'bcl-chips';
      row.dataset.chips = '';
      const addChip = ([value, name], isExtra) => {
        const chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'bcl-chip';
        chip.dataset.key = key;
        chip.dataset.value = value;
        if (isExtra) chip.dataset.extra = '';
        chip.textContent = name;
        chip.addEventListener('click', () => { this.active[key] = value; this.syncChips(); this.apply(); });
        row.appendChild(chip);
      };
      addChip(['', this.dataset.all], false);
      options.forEach(option => addChip(option, false));
      extra.forEach(option => addChip(option, true));
      if (extra.length) {
        group.dataset.collapsible = '';
        const more = document.createElement('button');
        more.type = 'button';
        more.className = 'bcl-more';
        const setLabel = open => {
          more.textContent = open ? this.dataset.less : this.dataset.more + ' (' + extra.length + ')';
          more.setAttribute('aria-expanded', String(open));
        };
        setLabel(false);
        more.addEventListener('click', () => {
          const open = !group.hasAttribute('data-expanded');
          group.toggleAttribute('data-expanded', open);
          setLabel(open);
          this.updateRows();
        });
        row.appendChild(more);
      }
      row.addEventListener('scroll', () => this.updateRow(row), { passive: true });
      group.append(label, row);
      this.filters.appendChild(group);
    });
    this.syncChips();
    if ('ResizeObserver' in window) new ResizeObserver(() => this.updateRows()).observe(this.filters);
  }
  updateRows() {
    this.filters.querySelectorAll('[data-chips]').forEach(row => this.updateRow(row));
  }
  updateRow(row) {
    const overflow = row.scrollWidth > row.clientWidth + 2;
    row.toggleAttribute('data-overflow', overflow);
    row.toggleAttribute('data-end', !overflow || row.scrollLeft + row.clientWidth >= row.scrollWidth - 2);
  }
  revealActive() {
    this.updateRows();
    this.filters.querySelectorAll('[data-chips][data-overflow]').forEach(row => {
      const chip = row.querySelector('.bcl-chip[aria-pressed="true"]:not([data-value=""])');
      if (!chip) return;
      row.scrollLeft += chip.getBoundingClientRect().left - row.getBoundingClientRect().left - 16;
      this.updateRow(row);
    });
  }
  syncChips() {
    this.filters.querySelectorAll('.bcl-chip').forEach(chip => chip.setAttribute('aria-pressed', String(this.active[chip.dataset.key] === chip.dataset.value)));
  }
  readUrl() {
    const params = new URLSearchParams(location.search);
    this.search.value = params.get('q') || '';
    ['spirit', 'technique', 'style'].forEach(key => { this.active[key] = params.get(key) || ''; });
    if (params.get('sort')) this.sort.value = params.get('sort');
    this.syncChips();
  }
  writeUrl() {
    const params = new URLSearchParams(location.search);
    ['q', 'spirit', 'technique', 'style', 'sort'].forEach(k => params.delete(k));
    if (this.search.value.trim()) params.set('q', this.search.value.trim());
    Object.entries(this.active).forEach(([k, v]) => { if (v) params.set(k, v); });
    if (this.sort.value !== 'az') params.set('sort', this.sort.value);
    const qs = params.toString();
    history.replaceState(null, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
  }
  apply() {
    const terms = this.search.value.toLowerCase().trim().split(/\s+/).filter(Boolean);
    let shown = 0;
    this.cards.forEach(card => {
      const hay = card.dataset.search || '';
      const textOk = terms.every(t => hay.includes(t));
      const filterOk = Object.entries(this.active).every(([key, value]) => !value || (card.dataset[key] || '').split(' ').includes(value));
      card.hidden = !(textOk && filterOk);
      if (!card.hidden) shown++;
    });
    const sorted = [...this.cards].sort((a, b) => {
      if (this.sort.value === 'quick') {
        const diff = (Number(a.dataset.minutes) || 99) - (Number(b.dataset.minutes) || 99);
        if (diff) return diff;
      }
      return a.dataset.title.localeCompare(b.dataset.title);
    });
    sorted.forEach(card => this.grid.appendChild(card));
    this.count.textContent = shown === 1 ? this.dataset.showingOne : this.dataset.showing.replace('[count]', String(shown));
    this.none.hidden = shown > 0;
    const dirty = terms.length > 0 || Object.values(this.active).some(Boolean);
    this.clear.hidden = !dirty;
    this.writeUrl();
  }
}
if (!customElements.get('biggar-cocktail-library')) customElements.define('biggar-cocktail-library', BiggarCocktailLibrary);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biggar-cocktail"] && !Shopify.designMode) return;
  try {
    
class BiggarCocktail extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.servings = this.querySelector('[data-servings]');
    this.status = this.querySelector('[data-status]');
    this.servings.addEventListener('change', () => this.updateAmounts());
    this.querySelectorAll('[data-ingredient-check]').forEach(input => input.addEventListener('change', () => this.updateChecklist()));
    this.querySelector('[data-print]').addEventListener('click', () => window.print());
    this.querySelectorAll('[data-enhanced]').forEach(element => element.hidden = false);
    this.updateAmounts();
    this.updateChecklist();
  }
  format(value) {
    return String(Math.round(value * 100) / 100);
  }
  updateAmounts() {
    const servings = Number(this.servings.value) || 1;
    this.querySelectorAll('[data-amount]').forEach(element => {
      const amount = Number(element.dataset.amount) * servings;
      const unit = amount === 1 ? element.dataset.unit : (element.dataset.unitPlural || element.dataset.unit);
      element.textContent = unit === 'each' ? this.format(amount) : `${this.format(amount)} ${unit}`;
    });
    this.querySelector('[data-yield]').textContent = servings === 1 ? this.dataset.yieldOne : this.dataset.yieldTemplate.replace('[count]', String(servings));
  }
  updateChecklist() {
    const inputs = [...this.querySelectorAll('[data-ingredient-check]')];
    const checked = inputs.filter(input => input.checked).length;
    this.status.textContent = (checked === inputs.length ? this.dataset.completeTemplate : this.dataset.checkTemplate)
      .replace('[count]', String(checked)).replace('[total]', String(inputs.length));
  }
}
if (!customElements.get('biggar-cocktail')) customElements.define('biggar-cocktail', BiggarCocktail);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biggar-mobile-buy-bar"] && !Shopify.designMode) return;
  try {
    
class BiggarBuyBar extends HTMLElement {
  connectedCallback() {
    if (this.started) return;
    this.started = true;
    try {
      this.variants = JSON.parse(this.querySelector('[data-bmb-variants]').textContent);
    } catch (error) {
      this.variants = {};
    }
    this.button = this.querySelector('[data-bmb-add]');
    this.priceEl = this.querySelector('[data-bmb-price]');
    this.wasEl = this.querySelector('[data-bmb-was]');
    this.optionEl = this.querySelector('[data-bmb-option]');
    this.phone = window.matchMedia('(max-width: 767px)');
    this.check = () => {
      if (this.queued) return;
      this.queued = true;
      const run = () => {
        if (!this.queued) return;
        this.queued = false;
        this.update(false);
      };
      requestAnimationFrame(run);
      setTimeout(run, 120);
    };
    window.addEventListener('scroll', this.check, { passive: true });
    window.addEventListener('resize', this.check);
    window.addEventListener('load', this.check);
    window.addEventListener('pageshow', this.check);
    document.addEventListener('visibilitychange', this.check);
    // Capital re-renders the swatches and buy buttons when the size changes,
    // so look the theme's button up again after any change on the page.
    document.addEventListener('change', () => {
      setTimeout(() => this.update(true), 150);
      setTimeout(() => this.update(true), 800);
    }, true);
    this.button.addEventListener('click', () => {
      const real = this.findReal();
      if (real && !real.disabled) real.click();
    });
    this.update(true);
  }

  findReal() {
    return document.querySelector('product-information [id^="ProductSubmitButton-"]') || document.querySelector('[id^="ProductSubmitButton-"]');
  }

  update(resync) {
    const real = this.findReal();
    if (!real) return;
    let show = false;
    if (this.phone.matches) {
      const box = real.getBoundingClientRect();
      show = !(box.height > 0 && box.bottom > 0 && box.top < window.innerHeight);
    }
    if (resync || (show && !this.showing)) this.sync(real);
    if (show === this.showing) return;
    this.showing = show;
    this.toggleAttribute('data-show', show);
    this.inert = !show;
    const root = document.documentElement;
    root.classList.toggle('bmb-on', show);
    if (show) root.style.setProperty('--bmb-height', this.offsetHeight + 'px');
  }

  sync(real) {
    const form = real.form;
    const input = form ? form.querySelector('[name="id"]') : null;
    const variant = input ? this.variants[input.value] : null;
    if (variant) {
      this.priceEl.textContent = variant.price;
      if (this.wasEl) {
        this.wasEl.textContent = variant.compare || '';
        this.wasEl.hidden = !variant.compare;
      }
      if (this.optionEl) this.optionEl.textContent = variant.title;
    }
    const soldOut = real.disabled;
    const label = soldOut ? this.dataset.soldOut : this.dataset.add;
    this.button.disabled = soldOut;
    this.button.textContent = label;
    this.button.setAttribute('aria-label', label + ': ' + this.dataset.name);
  }
}
if (!customElements.get('biggar-buy-bar')) customElements.define('biggar-buy-bar', BiggarBuyBar);

  } catch(e) { console.error(e); }
})();
})();
